export default "https://storage.googleapis.com/prepweb-prod/dist/4c23524b88bf20a18ad194d9d7e1f7b2.svg";